export default __webpack_public_path__ + "static/images/windows-app.7eed7500.png";